import { Route } from 'react-router-dom';
import Login from '../pages/users/Login';
import ForgotPassword from '../pages/users/ForgotPassword';
import ResetPassword from '../pages/users/ResetPassword';
import VerifyEmail from '../pages/users/VerifyEmail';
import Register2Fa from '../pages/users/Register2FA';
import Check2FA from '../pages/users/Check2FA';
import UserProfile from '../pages/users/UserProfile';
import LoginDocumentation from '../pages/users/LoginDocumentation';


export const UserRoutes = [
  <Route key="login" path="/login/:loginRoute" element={<Login />} />,
  <Route key="forgot" path="/forgot-password/:forgotRoute" element={<ForgotPassword />} />,
  <Route key="reset" path="/reset-password/:token" element={<ResetPassword />} />,
  <Route key="verify" path="/verify-email/:token" element={<VerifyEmail />} />,
  <Route key="register-2fa" path="/register-2fa" element={<Register2Fa />} />,
  <Route key="check-2fa" path="/check-2fa" element={<Check2FA />} />,
  <Route key="profile" path="/profile" element={<UserProfile />} />,
  <Route key="login-doc" path="/login-documentation/:email" element={<LoginDocumentation />} />,
];